export enum EthernetTypeEnum {
  ETHERNET_PRODUCT_MANAGED = "ETHERNET_PRODUCT_MANAGED",
  ETHERNET_PRODUCT_EFM = "ETHERNET_PRODUCT_EFM",
  ETHERNET_PRODUCT_GEA = "ETHERNET_PRODUCT_GEA",
  ETHERNET_PRODUCT_PTP = "ETHERNET_PRODUCT_PTP"
}
